import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const DebugTools: React.FC<{ children: React.ReactNode }> = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const history = useHistory();

  // Basic print of navigation
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      history.listen((location, action) => {
        console.groupCollapsed('History action:', action);
        console.log(JSON.stringify(location, null, 2));
        console.groupEnd();
      });
    }
  }, [history]);

  return <>{children}</>;
};

export default DebugTools;
